import React from 'react';
import {Icon, Map as LeafletMap, Marker, Polyline, Popup, TileLayer} from 'react-leaflet';
import Button from "@material-ui/core/Button/Button";
import Menu from "@material-ui/core/Menu/Menu";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import {withStyles} from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import PlaceIcon from "@material-ui/icons/Place";
import Input from "@material-ui/core/Input/Input";
import {latLngToString, calculateBounds} from "./Helpers";
import {bIcon, aIcon} from "./Map";
import {Context} from "./ContextProvider";
import * as Helpers from "./Helpers";
import L from "leaflet";
import * as Logger from "./Logger";

export const aIconGray = new L.Icon({
    iconUrl: './img/alpha-a-circle-gray.svg',
    iconAnchor: [18, 18],
    iconSize: [30, 30],
})

export const bIconGray = new L.Icon({
    iconUrl: './img/alpha-b-circle-gray.svg',
    iconAnchor: [18, 18],
    iconSize: [30, 30],
})

const style = theme => ({
    root: {
        width: "100%",
        height: `calc(100% - 170px)`,
        marginTop: 80,
        marginBottom: 60,
    }
})

function MapSelector(props) {
    let {state, dispatch} = React.useContext(Context);

    const {open, classes, point} = props;
    const [value, setValue] = React.useState("");

    // if we are changing old values we should set show old ones
    if (!value) {
        if (point === "start" && state.startPosition) {
            setValue(state.startPosition);
        } else if (point === "end" && state.endPosition) {
            setValue(state.endPosition)
        }
    }


    function handleLeftClick(mouseEvent) {
        const where = mouseEvent.latlng;
        setValue(where);
    }

    function hc() {
        if (props.handleCancel) {
            props.handleCancel()
        }
    }

    function ok() {
        if (point === "start") {
            setStart((value));
        } else if (point === "end") {
            setEnd(value);
        } else {
            console.error("UPS, wrong point. closing map");
        }

        // close window
        hc()
    }

    function setStart(latlng) {
        dispatch({type: "setStartOnMap", payload: latlng,});
        Helpers.coordinates2addressQuery(latlng, function (result) {
            Logger.log("start from map is under address");
            Logger.log(result);
            const st = result.address.city + " " + Helpers.concatIfExists(result.address.road) + Helpers.concatIfExists(result.address.house_number) + "(" + result.osm_id + ")";
            Logger.log(st);
            dispatch({type: "setStartDisplayName", payload: st})
        })
    }

    function setEnd(latlng) {
        dispatch({type: "setEndOnMap", payload: latlng});
        Helpers.coordinates2addressQuery(latlng, function (result) {
            Logger.log("start from map is under address");
            Logger.log(result);
            const st = result.address.city + " " + Helpers.concatIfExists(result.address.road) + Helpers.concatIfExists(result.address.house_number) + "(" + result.osm_id + ")";
            Logger.log(st);
            dispatch({type: "setEndDisplayName", payload: st})
        })
    }


    function getMarker() {

        //show current marker
        if (value) {
            return <Marker
                icon={point === "start" ? aIcon : bIcon}
                draggable={true}
                descr={point}
                position={value}
                onDragend={event => setValue(event.target.getLatLng())}>
                <Popup>
                    Here
                </Popup>
            </Marker>;
        }
    }

    function getGrayMarker() {
        // show "the other marker", disabled, not dragable
        if (point === "start" && state.endPosition) {
            return <Marker
                icon={bIconGray}
                draggable={false}
                descr={"end"}
                position={state.endPosition}>
                <Popup>
                    End
                </Popup>
            </Marker>;
        }

        if (point === "end" && state.startPosition) {
            return <Marker
                icon={aIconGray}
                draggable={false}
                descr={"Start"}
                position={state.startPosition}>
                <Popup>
                    Start
                </Popup>
            </Marker>;
        }
    }


    // ustalamy co ma być widoczne na mapie
    let bounds, zoom, center;
    center = value ? value : Helpers.defaultMapCenter;
    zoom = Helpers.defaultMapZoom;

    // jeśli mamy jeden punkt to center to jest ten punkt
    if (!state.startPosition && !state.endPosition) {
        zoom = Helpers.defaultMapZoom;
        center = value ? value : state.mapDefaultCenter ? state.mapDefaultCenter : Helpers.defaultMapCenter;
    } else {
        // jeśli mamy dwa punkty to ustawiamy bounds
        if (point === "start") {
            if (value) {
                if (state.endPosition) {
                    bounds = calculateBounds(value, state.endPosition);
                } else {
                    center = value;
                }
            } else {
                if (state.endPosition) {
                    center = state.endPosition;
                } else {
                    center = value ? value : (state.mapDefaultCenter ? state.mapDefaultCenter : Helpers.defaultMapCenter);
                }
            }
        }

        // paskudne copy paste
        if (point === "end" && state.startPosition) {
            if (value) {
                if (state.startPosition) {
                    bounds = calculateBounds(value, state.startPosition);
                } else {
                    center = value;
                }
            } else {
                if (state.startPosition) {
                    center = state.startPosition;
                } else {
                    center = value ? value : Helpers.defaultMapCenter;
                }
            }
        }
        if (!bounds) {
            zoom = Helpers.defaultMapZoom;
        }

    }


    return <div className={classes.root} style={{display: open ? '' : 'none'}}>
        <Input
            placeholder={point}
            fullWidth={true}
            value={value && latLngToString(value)}
        />
        <LeafletMap
            center={center}
            zoom={zoom}
            maxZoom={19}
            bounds={bounds}
            attributionControl={true}
            zoomControl={true}
            doubleClickZoom={false}
            scrollWheelZoom={true}
            dragging={true}
            animate={true}
            easeLinearity={0.35}
            onClick={handleLeftClick}
        >
            <TileLayer
                url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
            />
            {getMarker()}
            {getGrayMarker()}
        </LeafletMap>
        <Button color="secondary" disabled={!value} variant="contained" style={{width: "50%"}}
                onClick={ok}>Ok</Button>
        <Button variant="contained" style={{width: "50%"}} onClick={hc}>Cancel</Button>
    </div>;
}

export default withStyles(style)(MapSelector);
